import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import { Header } from "../../components/new/header/header";
import { translate } from "../../i18n";
import { ServiceRequestHome } from "../../screens/service-request/service-request-home";
import { ServiceRequestSpecificReservation } from "../../screens/service-request/service-request-specific-reservation";
import { CreateServiceRequest } from "../../screens/service-request/create-service-request";
import { ServiceRequestSummary } from "../../screens/service-request/service-request-summary";
import { deriveUnitTitle } from "../../utils";
import { colors } from "../../theme/colors";

const getUnitTitle = (route: any) => {
  const propertyUnit = route?.params?.propertyUnit;
  return deriveUnitTitle(propertyUnit);
};

const Stack = createStackNavigator();

export function ServiceSummaryStack() {
  return (
    <Stack.Navigator
      initialRouteName="ServiceRequestHome"
      screenOptions={{
        header: (props) => <Header {...props} />,
        headerMode: "screen",
        showFullMenu: true,
      }}>
      <Stack.Screen
        name="ServiceRequestHome"
        component={ServiceRequestHome}
        options={({ route }) => ({
          title: translate("serviceStack.requestService"),
          omitRightContent: true,
          omitBackButton: true,
        })}
      />
      <Stack.Screen
        name="CreateServiceRequest"
        component={CreateServiceRequest}
        options={({ route }) => ({
          title: translate("serviceStack.requestService"),
          omitRightContent: true,
        })}
      />
      <Stack.Screen
        name="ServiceRequestSpecificReservation"
        component={ServiceRequestSpecificReservation}
        options={({ route }: any) => ({
          header: (props) => <Header {...props} />,
          cardStyle: { backgroundColor: colors.background },
          title: getUnitTitle(route),
          omitRightContent: true,
        })}
      />
      <Stack.Screen
        name="ServiceRequestSummary"
        component={ServiceRequestSummary}
        options={({ route }) => ({
          header: (props) => <Header {...props} />,
          title: translate("serviceStack.requestService") as string,
          useLight: true,
          omitBackButton: true,
          omitRightContent: true,
        })}
      />
    </Stack.Navigator>
  );
}
